var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("DropUpload", {
        attrs: {
          configdata: _vm.configdata,
          jobcount: _vm.countMailbox,
          incart: _vm.jobsInCart
        },
        on: {
          "add-uploaded-jobs": _vm.addUploadedJobs,
          "upload-files-error": _vm.uploadFilesError,
          "show-spinner-modal": _vm.showSpinnerModal
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "block" }, [
        _c("div", { staticClass: "mailbox__navigation--mobile" }, [
          _c("div", { staticClass: "mailbox-navigation-items-wrapper" }, [
            _c("div", { staticClass: "mailbox-navigation-items-right" }, [
              _c(
                "div",
                {
                  class: {
                    "disabled__overlay--wrapper disabled__overlay--basket": true,
                    "disabled__overlay--active": _vm.cartIsEmpty()
                  }
                },
                [
                  _c("div", { staticClass: "disabled__overlay" }),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "cta cta--medium",
                      attrs: { href: this.config.routes.ebrief_cart }
                    },
                    [
                      _c("span", { staticClass: "cta__wrapper" }, [
                        _c("span", { staticClass: "cta__icon" }, [
                          _vm._v("  ")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "cta__text" }, [
                          _c("span", { staticClass: "cta--bold" }, [
                            _vm._v(
                              _vm._s(this.config.lang["mailbox.to_cart_button"])
                            )
                          ])
                        ])
                      ])
                    ]
                  )
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "block__content mailbox__block mailbox" },
          [
            _c("h3", { staticClass: "mailbox__headline-text" }, [
              _vm._v("\n        Diese Briefe "),
              _c("span", { staticClass: "h3--bold" }, [
                _vm._v("wurden hochgeladen")
              ]),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: this.countMailbox > 0,
                      expression: "this.countMailbox > 0"
                    }
                  ]
                },
                [_vm._v(" (" + _vm._s(this.countMailbox) + ")")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mailbox__headline" }, [
              _c("div", { staticClass: "headline-item-left" }, [
                _c(
                  "div",
                  {
                    class: {
                      "disabled__overlay--wrapper disabled__overlay--delete": true,
                      "disabled__overlay--active": _vm.jobsNotPresent
                    },
                    attrs: { id: "delete-all-link" }
                  },
                  [
                    _c("div", { staticClass: "disabled__overlay" }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: { href: "javascript:void(0);" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.deleteAllJobs()
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "icofont-trash" }),
                        _vm._v(
                          "\n              " +
                            _vm._s(this.config.lang["mailbox.delete_all"]) +
                            "\n            "
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: {
                      "disabled__overlay--wrapper disabled__overlay--add-all": true,
                      "disabled__overlay--active": _vm.readyJobsNotPresent()
                    },
                    attrs: { id: "add-all-link" }
                  },
                  [
                    _c("div", { staticClass: "disabled__overlay" }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "mailbox__iconlink_basketall",
                        attrs: { href: "javascript:void(0);" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.pushReadyToCart()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(this.config.lang["mailbox.add_all"]) +
                            "\n            "
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "headline-item-right" }, [
                _c("div", { staticClass: "item-right--button" }, [
                  _c(
                    "div",
                    {
                      class: {
                        "disabled__overlay--wrapper disabled__overlay--basket": true,
                        "disabled__overlay--active": _vm.cartIsEmpty()
                      }
                    },
                    [
                      _c("div", { staticClass: "disabled__overlay" }),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "cta cta--medium",
                          attrs: { href: this.config.routes.ebrief_cart }
                        },
                        [
                          _c("span", { staticClass: "cta__wrapper" }, [
                            _vm._m(0),
                            _vm._v(" "),
                            _c("span", { staticClass: "cta__text" }, [
                              _c("span", { staticClass: "cta--bold" }, [
                                _vm._v(
                                  _vm._s(
                                    this.config.lang["mailbox.to_cart_button"]
                                  )
                                )
                              ])
                            ])
                          ])
                        ]
                      )
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", {
              class: {
                mailbox__empty: true,
                "mailbox__empty--is-empty": _vm.jobsNotPresent
              },
              domProps: {
                innerHTML: _vm._s(this.config.lang["account.jobs.empty"])
              }
            }),
            _vm._v(" "),
            _vm._l(_vm.jobs, function(job) {
              return _c("MailboxJob", {
                key: job.pid,
                attrs: { configdata: _vm.configdata, pid: job.pid, job: job },
                on: {
                  "add-job-to-cart": _vm.addJobToCart,
                  "remove-job": _vm.editJobDelete,
                  "edit-job": _vm.editJob,
                  "preview-job": _vm.previewJob,
                  "reload-job": _vm.reloadJob
                }
              })
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "modalfade" } },
        [
          _c("EditControl", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isEditModalVisible,
                expression: "isEditModalVisible"
              }
            ],
            attrs: { configdata: _vm.configdata, jobpid: _vm.editJobPid },
            on: {
              "edit-job-close": _vm.editJobClose,
              "edit-job-delete": _vm.editJobDelete,
              "edit-job-edit": _vm.editJobEdit,
              "show-spinner-modal": _vm.showSpinnerModal
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "modalfade" } },
        [
          _c("JobPreview", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isPreviewModalVisible,
                expression: "isPreviewModalVisible"
              }
            ],
            attrs: { configdata: _vm.configdata, jobpid: _vm.previewJobPid },
            on: {
              "preview-loaded": _vm.previewLoaded,
              "preview-job-close": _vm.previewJobClose,
              "preview-job-accept": _vm.previewJobAccept,
              "preview-job-delete": _vm.previewJobDelete,
              "show-spinner-modal": _vm.showSpinnerModal,
              "show-error": _vm.showErrorMessage
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "modalfade" } },
        [
          _c("ErrorModal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isErrorModalVisible,
                expression: "isErrorModalVisible"
              }
            ],
            attrs: { error: this.modalError },
            on: { "close-error-message": _vm.closeErrorMessage }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "modalfade" } },
        [
          _c("SpinnerModal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isSpinnerModalVisible,
                expression: "isSpinnerModalVisible"
              }
            ]
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "cta__icon" }, [
      _c("i", { staticClass: "icofont-basket" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }